import * as React from "react";
import "./shield-dome.css";
import { IconMapPin, IconPumpkinScary, IconShield } from "@tabler/icons-react";

export function DistrictMap({ nodes, userId, objective, onSelect, selected, now }) {
  const [elapsed, setElapsed] = React.useState(0);
  React.useEffect(() => { setElapsed(0); const start = Date.now(); const timer = setInterval(() => setElapsed((Date.now()-start)/1000),1000); return () => clearInterval(timer); }, [now]);
  const shieldTime = (now ?? Date.now()/1000) + (now == null ? 0 : elapsed);
  const [zoom, setZoom] = React.useState(1.2);
  const viewport = React.useRef(null);
  const zoomRef = React.useRef(1.2);
  const animation = React.useRef(null);
  const anchor = React.useRef(null);
  const size = 1000 * zoom;
  const center = React.useCallback((x = .5, y = .5) => {
    const element = viewport.current;
    if (element) element.scrollTo({ left: x * size - element.clientWidth / 2, top: y * size - element.clientHeight / 2, behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ? "auto" : "smooth" });
  }, [size]);
  React.useLayoutEffect(() => {
    const element = viewport.current;
    if (element && anchor.current) {
      element.scrollLeft = anchor.current.x * size - element.clientWidth / 2;
      element.scrollTop = anchor.current.y * size - element.clientHeight / 2;
    }
    zoomRef.current = zoom;
  }, [zoom, size]);
  React.useEffect(() => {
    const element = viewport.current;
    if (element) { element.scrollLeft = (size - element.clientWidth) / 2; element.scrollTop = (size - element.clientHeight) / 2; }
    return () => cancelAnimationFrame(animation.current);
  }, []);
  function changeZoom(delta) {
    const element = viewport.current;
    if (!element) return;
    cancelAnimationFrame(animation.current);
    const start = zoomRef.current;
    const end = Math.max(.6, Math.min(1.6, Math.round((start + delta) * 10) / 10));
    if (start === end) return;
    anchor.current = { x: (element.scrollLeft + element.clientWidth / 2) / (1000 * start), y: (element.scrollTop + element.clientHeight / 2) / (1000 * start) };
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) { setZoom(end); return; }
    const started = performance.now();
    function frame(now) {
      const progress = Math.min(1, (now - started) / 240);
      const eased = 1 - (1 - progress) ** 3;
      setZoom(start + (end - start) * eased);
      if (progress < 1) animation.current = requestAnimationFrame(frame);
    }
    animation.current = requestAnimationFrame(frame);
  }
  return <div className={`kh-map ${zoom < .8 ? "is-overview" : ""}`}>
    <div className="kh-map__viewport" ref={viewport} tabIndex={0} aria-label="Карта района. Прокручивайте, чтобы осмотреть соседей" onPointerDown={() => { cancelAnimationFrame(animation.current); anchor.current = null; }}>
      <div className="kh-map__field" style={{ width: size, height: size, "--kh-zoom": zoom }}>
        <svg className="kh-map__paths" viewBox="0 0 1000 1000" aria-hidden="true"><defs><pattern id="kh-hex" width="68" height="59" patternUnits="userSpaceOnUse"><path d="M17 0 51 0 68 29.5 51 59 17 59 0 29.5Z" fill="none" stroke="#be9b7225" /></pattern></defs><rect width="1000" height="1000" fill="url(#kh-hex)" /></svg>
        {nodes.map(node => <button type="button" key={node.id} className={`kh-map__nest ${node.id === userId ? "is-self" : ""} ${selected === node.id ? "is-selected" : ""} ${node.shield_until > shieldTime ? "has-shield" : ""}`}
          style={{ left: `${node.x * 100}%`, top: `${node.y * 100}%` }} onClick={() => onSelect(node.id)} aria-label={`${node.id === userId ? "Ваше гнездо" : node.name}, ${node.score} очков`}>
          {node.shield_until > shieldTime && <div className="kh-map__dome" aria-hidden="true" />}
          <img src="/assets/king-hill/nest.webp" alt="" draggable="false" /><span>{node.id === userId ? "Моё гнездо" : node.name}</span>
          {node.shield_until > shieldTime && <i aria-label="Гнездо под щитом"><IconShield size={12} /></i>}
        </button>)}
        <button type="button" className={`kh-map__pumpkin ${selected === "pumpkin" ? "is-selected" : ""}`} onClick={() => onSelect("pumpkin")} aria-label="Главная тыква" style={{ left: "50%", top: "50%" }}>
          <img src="/assets/king-hill/pumpkin.webp" alt="" draggable="false" /><span>Главная тыква</span><small>{objective.hp > 0 ? `Туман: ${objective.hp}` : objective.owner_name || "Свободна"}</small>
        </button>
      </div>
    </div>
    <div className="kh-map__legend"><span><IconMapPin size={14} />Карта района</span><small>{nodes.length} гнёзд · нажмите на цель</small></div>
    <div className="kh-map__controls"><button type="button" aria-label="Приблизить карту" onClick={() => changeZoom(.2)}>+</button><button type="button" aria-label="Отдалить карту" onClick={() => changeZoom(-.2)}>−</button><button type="button" aria-label="Перейти к моему гнезду" onClick={() => { const self = nodes.find(n => n.id === userId); if (self) center(self.x, self.y); }}><IconMapPin size={19} /></button><button type="button" aria-label="Перейти к тыкве" onClick={() => center()}><IconPumpkinScary size={20} /></button></div>
  </div>;
}
